
<div class="container" [style.border-radius]="borderRadius" [style.width]="width" [style.height]="height">
  <div class="container-video {{gradientClass}}-gradient" [style.height]="getVideoHeight()">
    <!-- <div class="sale {{ saleClass }}" [style.border-top-left-radius]="borderRadius" [style.border-bottom-right-radius]="borderRadius">
      {{ saleText }}
    </div> -->
<!--    <div class="ivitrina-sign">-->
<!--      <img class="sign-ivitrina" src="../../../assets/images/new-design-icons/initrina-sign/{{ gradientClass }}-gradient.svg" alt="">-->
<!--    </div>-->
    <div class="full-screen" *ngIf="isMobile" (click)="openFullScreen()">
      <img src="assets/images/new-design-icons/Full-Screen%20(white).svg"/>
      <button class="sound-button" *ngIf="isPlayerReady && player && !player.paused()" (click)="changeSound($event)">
        <img *ngIf="!player.muted()" src="assets/images/new-design-icons/sound.svg">
        <img *ngIf="player.muted()" src="assets/images/new-design-icons/sound-off.svg">
      </button>
    </div>
    <div class="full-screen" *ngIf="isMobile" (click)="openFullScreen()">
      <img src="assets/images/new-design-icons/Full-Screen%20(white).svg"/>
    </div>
    <div class="top">
      <button class="sound-button" *ngIf="isPlayerReady && player && !player.paused() && !isMobile" (click)="changeSound($event)">
        <img *ngIf="!player.muted()" src="assets/images/new-design-icons/sound.svg">
        <img *ngIf="player.muted()" src="assets/images/new-design-icons/sound-off.svg">
      </button>
    </div>
    <div class="poster" *ngIf="showPoster" [class.active]="isActive" [style.border-radius]="borderRadius" [style.background-image]="getPoster()"></div>
    <video
        [style.border-radius]="borderRadius"
        [class.active]="isActive"
        #videoPlayer
        class="video"
        [id]="videoId"
        playsinline
        loop
        [controls]="false"
    >
    </video>
    <div class="pause-btn" *ngIf="isPlayerReady && player && player.paused()" (click)="handleVideo($event)">
      <img class="play" src="assets/images/new-design-icons/play-video.svg" alt="play" />
    </div>
    <div class="title">{{ videoInfo.title }}</div>

    <div class="object-info" *ngIf="isActive" (click)="clickInfo()">
      <div class="price {{gradientClass}}-gradient">{{ videoInfo.price | mask : 'separator.2' }} ₸</div>
<!--      <div class="description">Ипотеки «Отау» и «Наурыз» в 2025 году будут работать по одинаковым условиям. Ориентировочно их запустят в марте.</div>-->
    </div>
  </div>
</div>